import React from 'react'

const PaperPlaneTiltIcon = ({color = '#735bf2'}: {color: string}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_12223_47307)'>
        <path
          d='M10.125 13.875L15 9'
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.9706 3.95343C21.0068 3.82513 21.0081 3.68952 20.9744 3.56055C20.9408 3.43159 20.8733 3.31392 20.7791 3.21967C20.6848 3.12542 20.5672 3.05799 20.4382 3.02432C20.3092 2.99065 20.1736 2.99196 20.0453 3.02812L2.04531 8.48624C1.89836 8.52771 1.76756 8.61306 1.67041 8.73086C1.57326 8.84866 1.51438 8.99331 1.50164 9.14547C1.4889 9.29763 1.52291 9.45006 1.59912 9.58238C1.67533 9.71469 1.79011 9.8206 1.92813 9.88593L10.1247 13.8741L14.1128 22.0697C14.1781 22.2077 14.284 22.3225 14.4164 22.3987C14.5487 22.4749 14.7011 22.5089 14.8533 22.4962C15.0054 22.4834 15.1501 22.4245 15.2679 22.3274C15.3857 22.2302 15.471 22.0994 15.5125 21.9525L20.9706 3.95343Z'
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_12223_47307'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PaperPlaneTiltIcon
